// Mapa intercalado en dos filas (Jump Fitness / Dance Fit).
// Cada layout lista los lugares de izquierda a derecha; 'C' es el coach.
// Cada elemento ocupa 2 medias columnas y avanza 1, así las filas quedan desfasadas.
export const STAGGERED_LAYOUTS = {
  // Fila de atrás: [2][C][5][7]  ·  Fila de enfrente: [1][3][4][6]
  'Jump Fitness': {
    firstRow: 'bottom',
    order: [1, 2, 3, 'C', 4, 5, 6, 7],
  },
  // Fila de atrás: [1][3][C][6][8]  ·  Fila de enfrente: [2][4][5][7][9]
  'Dance Fit': {
    firstRow: 'top',
    order: [1, 2, 3, 4, 'C', 5, 6, 7, 8, 9],
  },
};

const StaggeredSeats = ({ classDetails, handleShow }) => {
  const seats     = classDetails.seats;
  const coachImg  = classDetails.class.coach_image;
  const coachName = classDetails.class.coach_name;
  const layout    = STAGGERED_LAYOUTS[classDetails.class.type_class];

  const getSeat = (num) => seats.find((s) => s.seat_number === num);

  const renderSeat = (num, style) => {
    const s = getSeat(num);
    if (!s) return null;
    return (
      <div
        key={s.id}
        className={`bola-seat ${s.status === 1 ? 'ocupado' : ''}`}
        style={style}
        onClick={() => s.status !== 1 && handleShow(s.seat_number)}
      >
        <span>{s.seat_number}</span>
      </div>
    );
  };

  const renderCoach = (style) =>
    coachImg ? (
      <div
        key="coach"
        className="bola-coach staggered-coach"
        style={{ ...style, backgroundImage: `url(${require(`../images/coaches/${coachImg}`)})` }}
      />
    ) : (
      <div key="coach" className="bola-coach staggered-coach" style={style}>
        <span className="name-coach">{coachName || 'Coach'}</span>
      </div>
    );

  const firstRow = layout.firstRow === 'top' ? 1 : 2;

  return (
    <div className="ride-grid-wrapper">
      <div
        className="staggered-grid"
        style={{ gridTemplateColumns: `repeat(${layout.order.length + 1}, var(--staggered-col))` }}
      >
        {layout.order.map((item, i) => {
          const style = {
            gridColumn: `${i + 1} / span 2`,
            gridRow: i % 2 === 0 ? firstRow : 3 - firstRow,
          };
          return item === 'C' ? renderCoach(style) : renderSeat(item, style);
        })}
      </div>
    </div>
  );
};

export default StaggeredSeats;
